import { render } from "./banner.vue?vue&type=template&id=6dda4a62&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=6dda4a62&lang=scss&scoped=true"

import exportComponent from "/Users/bill/rongge/code/已售项目/20340305/front/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dda4a62"]])

export default __exports__